module.exports = __webpack_public_path__ + "img/6.c6b71152.png";